export const airportCodeMap = new Map<string, string>([
  ["LHR", "London Heathrow"],
  ["LGW", "London Gatwick"],
  ["STN", "London Stansted"],
  ["LTN", "London Luton"],
  ["LCY", "London City"],
  ["SEN", "London Southend"],
  ["BRS", "Bristol"],
  ["BHX", "Birmingham"],
  ["MAN", "Manchester"],
  ["LPL", "Liverpool"],
  ["EMA", "East Midlands"],
  ["LBA", "Leeds Bradford"],
  ["NCL", "Newcastle"],
  ["EDI", "Edinburgh"],
  ["GLA", "Glasgow"],
  ["CWL", "Cardiff"],
  ["ABZ", "Aberdeen"],
  ["BFS", "Belfast"],
  ["BOH", "Bournemouth"],
  ["SOU", "Southampton"],
  ["EXT", "Exeter"],
  ["DUB", "Dublin"],
  ["GCI", "Guernsey"],
  ["None", "NA"]
]);
